import React, { useEffect, useState } from 'react'; 
import { useLocalizedStrings } from '../../Localization';
import { Button, Card, CardBody, CompactSidebarNavTrigger, Heading, Icon, NumberDisplay, Page } from '@aidkitorg/component-library';
import { AdminPanelNav } from '../AdminPanelApp';
import { usePayments } from '../../Contexts/PaymentsContext';
import { PaymentBatchRecipient, PaymentBatchRecipientsDataTable } from './components/PaymentBatchRecipientsDataTable';


export const PaymentBatchDetailsPage = () => {
  const [paymentRecipientDetails, setPaymentRecipientDetails] = useState<Array<PaymentBatchRecipient>>([])

  const L = useLocalizedStrings()
  const { getRecipientDetailsByBatch } = usePayments();

  useEffect(() => {
    const recipientDetails = getRecipientDetailsByBatch("BATCH_NAME")    
    setPaymentRecipientDetails(recipientDetails)
  }, [])

  const totalRecipientsCard = <NumberDisplay 
    title="Total Recipients"
    value={paymentRecipientDetails.length}
    iconName="UsersIcon"
    iconColor='blue'
  />

  const paymentStatusCard = <Card className="min-w-80 rounded-md">
    <CardBody className="py-2 overflow-auto">
      <div className="flex justify-between gap-2">
        <div>
          <div className="text-sm text-gray-500">Payment Status</div>
          <div className="text-2xl font-semibold" tabIndex={0}>Approved</div>
        </div>
        <div className="size-[48px] rounded-md bg-green-100">
          <Icon 
            className="stroke-[1.5] font-semibold m-2 text-green-600"
            size="lg" 
            role="decorative" 
            name="CheckBadgeIcon" />
        </div>

      </div>
    </CardBody>
  </Card>

  const header = (
    <div>
      <div className="flex gap-4 items-center">
        <CompactSidebarNavTrigger />     
        <div className="flex gap-2 items-center">
          <Button href="/admin-panel/payments" variant="link">
            Payments
          </Button>
          <Icon size="sm" role="decorative" name="ChevronRightIcon"/>
          <Button href="/admin-panel/payments/payment-details/payment-id" variant="link">
            Payment Details
          </Button>
        </div>
      </div>
      <div>
        <Heading level="h1" className="m-0">March Housing Assistance</Heading>
      </div>
    </div>
  )
  
  const footer = (
    <div className="w-full flex justify-between">
      <div>
        <Button variant="link" href="/privacy.html" openInNewWindow>
          {L.privacy_policy}
        </Button>
      </div>
      <div>
        <Button variant="link" href="/tos.html" openInNewWindow>
          {L.terms_and_conditions}
        </Button>
      </div>
    </div>
  )
  
  return (
    <Page 
      className="bg-gray-50 h-screen "
      header={header}
      sidebar={
        <AdminPanelNav />
      }
      footer={footer}
    >
      <div className="flex flex-col gap-4">
        <div className="flex gap-2">
          <div>
            {totalRecipientsCard}
          </div>
          <div>
            {paymentStatusCard}
          </div>
          
        </div>
        <div className="border rounded-md p-4 bg-white">
          <PaymentBatchRecipientsDataTable />
        </div>
      </div>
    </Page>
  )
}